module.exports = __webpack_public_path__ + "static/media/xls.ea52a1b5.svg";